import AES from "@ali/aes-tracker";
// import AESPluginPV from "@ali/aes-tracker-plugin-pv";
// import AESPluginEvent from "@ali/aes-tracker-plugin-event";
// import AESPluginAPI from "@ali/aes-tracker-plugin-api";
// import AESPluginAutolog from "@ali/aes-tracker-plugin-autolog";
// import AESPluginJSError from "@ali/aes-tracker-plugin-jserror";
// import AESPluginResourceError from "@ali/aes-tracker-plugin-resourceError";
// import AESPluginPerf from "@ali/aes-tracker-plugin-perf";
// import AESPluginEventTiming from "@ali/aes-tracker-plugin-eventTiming";
// import AESPluginBlank from "@ali/aes-tracker-plugin-blank";
// import AESPluginLongTask from "@ali/aes-tracker-plugin-longtask";
import AESPluginSurvey from "@ali/aes-tracker-plugin-survey";
import { getEnv, getUserID } from "./utils";
import Aplus from "./aplus";
const env = getEnv();
export default class AEM {
    aes = null;
    constructor(pid, uid) {
        if (env !== "prod")
            return; // 只在生产环境加埋点
        new Aplus();
        this.init(pid, uid);
    }
    init(pid, uid) {
        this.aes = new AES({
            pid,
            user_type: "14",
            uid: uid || getUserID(),
            env,
        });
        window.CPOMonitor = window.CPOMonitor || {};
        window.CPOMonitor.aes = this.aes;
        window.AES = this.aes;
    }
    // // 页面pv
    // usePvPlugin(config = {}) {
    //   if (this.aes === null) return;
    //   window.CPOMonitor = window.CPOMonitor || {};
    //   window.CPOMonitor.pvPlugin = this.aes.use(AESPluginPV, config);
    // }
    // // 自定义事件
    // useEventPlugin() {
    //   if (this.aes === null) return;
    //   window.CPOMonitor = window.CPOMonitor || {};
    //   window.CPOMonitor.sendEvent = this.aes.use(AESPluginEvent);
    // }
    // // 接口
    // useApiPlugin(config = {}) {
    //   if (this.aes === null) return;
    //   window.CPOMonitor = window.CPOMonitor || {};
    //   window.CPOMonitor.apiPlugin = this.aes.use(AESPluginAPI, {
    //     parseResponse: function () {
    //       return {
    //         params: "",
    //         body: "",
    //         response: "",
    //       };
    //     },
    //     ...config,
    //   });
    // }
    // // js异常
    // useJsErrorPlugin(config = {}) {
    //   if (this.aes === null) return;
    //   window.CPOMonitor = window.CPOMonitor || {};
    //   window.CPOMonitor.jsErrorPlugin = this.aes.use(AESPluginJSError, config);
    // }
    // // 资源异常
    // useResourceErrorPlugin(config = {}) {
    //   if (this.aes === null) return;
    //   window.CPOMonitor = window.CPOMonitor || {};
    //   window.CPOMonitor.resourceErrorPlugin = this.aes.use(
    //     AESPluginResourceError,
    //     config
    //   );
    // }
    // // 性能
    // usePerfPlugin(config = {}) {
    //   if (this.aes === null) return;
    //   window.CPOMonitor = window.CPOMonitor || {};
    //   window.CPOMonitor.perfPlugin = this.aes.use(AESPluginPerf, config);
    // }
    // // 响应延迟
    // useEventTimingPlugin() {
    //   if (this.aes === null) return;
    //   this.aes.use(AESPluginEventTiming);
    // }
    // // 卡顿
    // useLongTaskPlugin() {
    //   if (this.aes === null) return;
    //   this.aes.use(AESPluginLongTask);
    // }
    // // 白屏
    // useBlankPlugin(config = {}) {
    //   if (this.aes === null) return;
    //   window.CPOMonitor = window.CPOMonitor || {};
    //   window.CPOMonitor.blankPlugin = this.aes.use(AESPluginBlank, config);
    // }
    // // 点击曝光
    // useAutologPlugin(config = {}) {
    //   if (this.aes === null) return;
    //   window.CPOMonitor = window.CPOMonitor || {};
    //   window.CPOMonitor.autologPlugin = this.aes.use(AESPluginAutolog, config);
    // }
    // 满意度问卷
    useSurveyPlugin(config = {}) {
        if (this.aes === null)
            return;
        window.CPOMonitor = window.CPOMonitor || {};
        window.CPOMonitor.surveyPlugin = this.aes.use(AESPluginSurvey, config);
    }
    // 使用常用埋点
    useCommonPlugins(config) {
        if (this.aes === null)
            return;
        const { 
        // pvConfig = {
        //   enableHistory: true,
        // },
        // apiConfig = {},
        // jsErrorConfig = {},
        // resourceErrorConfig = {},
        // perfConfig = {},
        // blankConfig = pidMapToBlankConfig[this.aes.getConfig("pid")] || {},
        surveyConfig = {} } = config ?? {};
        // this.usePvPlugin(pvConfig);
        // this.useEventPlugin();
        // this.useApiPlugin(apiConfig);
        // this.useJsErrorPlugin(jsErrorConfig);
        // this.useResourceErrorPlugin(resourceErrorConfig);
        // this.usePerfPlugin(perfConfig);
        // this.useEventTimingPlugin();
        // this.useLongTaskPlugin();
        // this.useBlankPlugin(blankConfig);
        this.useSurveyPlugin(surveyConfig);
    }
}
